var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('iframe',{staticStyle:{"width":"100vw","height":"90vh"},attrs:{"src":"https://docs.google.com/presentation/d/e/2PACX-1vRoRbIeynbngvV5ipx4KB-I20CHRYGcyV1vL2C-aOddTdYLrx8Y4w8HNPB6k4FuH4fy3dFm_kXuCPKq/embed?start=false&loop=false&delayms=3000"}})])
}]

export { render, staticRenderFns }